import type { CorpusConfig, FileProcessingConfig } from './serviceExecutionApi';

export const initialCorpus: CorpusConfig = { unit: 'FRAGMENT', language: 'mixed', normalize_unicode: true,
  lowercase: false, remove_html: false, tokenize: true, deduplicate: false, max_units: 1000, metadata_fields: [], grouping_variables: [] };
export const initialProcessing: FileProcessingConfig = { operation: 'ZIP', prefix: 'result', pages_per_file: 10, deduplicate: false, compress_pdf: false };

